// extracted by mini-css-extract-plugin
module.exports = {"path":"Counter_path__2-78b","counter":"Counter_counter__2lilZ","finish":"Counter_finish__2yPJk","remaining":"Counter_remaining__1fflw"};